const AUTH_API = {
	RESET_EXPIRED_USER: 'public/auth/resetExpiredUser',
	TWO_STEP_AUTHENTICATION_REGISTER: 'twoFactor/register',
	TWO_STEP_AUTHENTICATION_VALIDATE: 'twoFactor/validate'
};

export default AUTH_API;
